import Empty from 'constants/empty';

/**
 * Normalizes the possible Contentful/custom-rendering payload shapes used by Benefits sections.
 */
const getBenefitsViewState = props =>
    props.benefitsViewState || props.state || props.benefitsState || props.content?.state || props.content || Empty.Object;

export default getBenefitsViewState;
